<template>
    <div class="MatchContainerWrapped-logo shadow">
        <img :src="srcLogo" alt="logo"/>
        <div class="MatchContainerWrapped-info">
            <p>VS</p>
            <h3 class="text-uppercase text-truncate">{{match.opponent}}</h3>
            <p>{{match.date | date}}</p>
        </div>
    </div>
</template>

<script>
    import Match from "@/models/Match";
    export default {
        name: "MatchContainerWrapped",
        data() {
            return {
                srcLogo: require('@/assets/media/logo.svg'),
            }
        },
        props: {
            match: {
                type: Object,
                default: () => Object.assign({}, Match)
            },
        },
    }
</script>

<style scoped>

</style>